import React, { useState } from "react";
import SectionTitle from "./shared/SectionTitle";
import GalleryImage from "./GalleryImage";
import { X } from "lucide-react";

function BusinessCard() {
	const photo = {
		id: "business-card", // Add unique IDs if needed for keys
		src: "/images/business-card.jpeg",
		alt: "PCB Business Card",
		description: "Custom PCB Business Card.",
	};

	// State for modal (Keep this in the parent component)
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedImage, setSelectedImage] = useState(null);

	const openModal = (image) => {
		setSelectedImage(image);
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
		setSelectedImage(null);
	};
	return (
		<section className="max-w-6xl mx-auto">
			<SectionTitle>Custom PCB Business Card Project</SectionTitle>
			<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl overflow-hidden mb-12">
				<div className="flex flex-col md:flex-row">
					<div className="p-8 md:p-10">
						<p className="mb-6 text-lg leading-relaxed text-slate-600">
							For this project, I designed and built a custom PCB
							business card. In addition to being a functional
							business card, this card includes an embedded
							antenna and STM ST25TV02K NFC chip to build in NFC
							functionality to the card itself. Finally, there is
							a schematic, layout, and pads for an additional
							circuit which uses a microcontroller and support
							components. This circuit takes in 5V power from a
							header and regulates it to 3.3V. Then I added a
							power indicator LED for both 5V and 3.3V power, as
							well as a UART output header.
						</p>
						<p className="mb-6 text-lg leading-relaxed text-slate-600">
							To create this, I used Altium Designer to create
							both the schematics and layout. As reference for the
							microcontroller schematic, I used the "Getting
							Started with STM32F030XX Series Hardware
							Development" document provided by STM. I then added
							the rest of the necessary components based on my
							previous circuit design experience.
						</p>
						<p className="text-lg leading-relaxed text-slate-600">
							Finally, I implemented the antenna based on the
							standard 13.56 MHz NFC specifications. To find the
							correct number of loops for the antenna, I used the
							STM NFC Antenna Configurator website and entered my
							preferred boundaries. I then manually copied the
							antenna design into my PCB layout using traces.
						</p>
					</div>
				</div>
			</div>
			<div className="bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 mb-12">
				<div className="grid grid-cols-1 md:grid-cols-1 gap-4 justify-center">
					<div className="flex justify-center">
						<GalleryImage image={photo} onImageClick={openModal} />
					</div>
				</div>
			</div>

			{/* Modal (Keep this rendering logic in the parent) */}
			{isModalOpen && selectedImage && (
				<div
					className="fixed inset-0 bg-slate-950/70 backdrop-blur-xs flex items-center justify-center z-50 p-4 animate-fade-in"
					onClick={closeModal} // Close modal on overlay click
				>
					<div
						className="bg-white rounded-2xl shadow-lift max-w-3xl w-full relative p-4 animate-scale-in"
						onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal content
					>
						<button
							onClick={closeModal}
							className="absolute top-3 right-3 text-slate-500 hover:text-slate-900 z-10 bg-white/90 ring-1 ring-slate-200 rounded-full p-1.5 transition-colors"
							aria-label="Close modal"
						>
							<X size={22} />
						</button>
						<div className="max-h-[80vh] overflow-auto">
							<img
								src={selectedImage.src}
								alt={selectedImage.alt}
								className="w-full h-auto object-contain rounded-xl mb-4 max-h-[65vh]"
							/>
							<p className="text-center text-slate-600 px-4 pb-2">
								{selectedImage.description}
							</p>
						</div>
					</div>
				</div>
			)}
		</section>
	);
}

export default BusinessCard;
